import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  fr: {
    nav: {
      manifesto: "Manifeste",
      services: "Services",
      approach: "Le fondateur",
      proof: "Preuves",
      book: "Réserver un appel",
      studio: "AI DEPLOYMENT STUDIO — EU",
    },
    hero: {
      overline: "STUDIO DE DÉPLOIEMENT IA — EUROPE",
      lines: ["L'IA SEULE", "NE RAPPORTE", "RIEN."],
      sub: "Stratégie de déploiement IA & Forward Deployment Engineering. Nous entrons dans votre métier, formons vos équipes et rendons vos modèles rentables.",
      cta1: "Réserver un appel découverte",
      cta2: "Lire le manifeste",
      ticks: ["ROI D'ABORD", "CONFORME AI ACT", "FR · EN · DE"],
      caption: "PARIS — 48.8566° N, 2.3522° E",
      scroll: "DÉFILER",
    },
    marquee: ["FORWARD DEPLOYMENT", "AI STRATEGY", "COMPLIANCE", "ENABLEMENT", "ROI", "TERRAIN"],
    manifesto: {
      overline: "LE MANIFESTE",
      heading: "Quatre vérités que le marché refuse d'entendre.",
      chapters: [
        {
          n: "01",
          t: "Sans guide, l'IA est un coût.",
          b: "Des licences achetées, des pilotes abandonnés, des équipes qui contournent l'outil. L'IA déployée sans accompagnement ne produit aucun retour — elle en consomme. La rentabilité n'est pas une fonctionnalité du modèle : c'est une discipline de déploiement.",
        },
        {
          n: "02",
          t: "Le métier d'abord. Le modèle ensuite.",
          b: "On ne peut pas automatiser ce qu'on ne comprend pas. Nous commençons sur le terrain : vos processus, vos contraintes, vos marges. La technologie arrive après — calibrée sur votre réalité opérationnelle, jamais l'inverse.",
        },
        {
          n: "03",
          t: "Former vaut mieux que livrer.",
          b: "Un outil livré sans adoption est un échec déguisé. Nous formons vos équipes, installons des rituels d'usage et mesurons l'adoption jusqu'à ce que l'IA devienne un réflexe collectif — pas une ligne de dépense.",
        },
        {
          n: "04",
          t: "La conformité est un avantage.",
          b: "AI Act, RGPD, gouvernance : ce que d'autres subissent, nous le transformons en argument de vente. Un déploiement conforme est un déploiement durable — et un signal de confiance pour vos clients.",
        },
      ],
    },
    services: {
      overline: "SERVICES",
      heading: "Ce que nous déployons, nous le rentabilisons.",
      items: [
        {
          n: "S.01",
          t: "AI Deployment Strategy",
          b: "Audit de vos processus, cas d'usage priorisés par ROI, feuille de route de déploiement à 90 jours. Zéro pilotage à l'instinct.",
        },
        {
          n: "S.02",
          t: "Forward Deployment Engineering",
          b: "Des ingénieurs embarqués dans vos équipes, qui construisent sur votre terrain — avec vos données, vos outils, vos contraintes.",
        },
        {
          n: "S.03",
          t: "Enablement & Training",
          b: "Formation des équipes, rituels d'adoption, mesure d'usage. L'IA devient un réflexe collectif, pas un gadget de direction.",
        },
        {
          n: "S.04",
          t: "Compliance & AI Act",
          b: "Cartographie des risques, gouvernance, conformité européenne. Transformez la régulation en argument commercial.",
        },
      ],
    },
    founder: {
      overline: "LE FONDATEUR",
      heading: "Entrepreneur. Référent compliance. Opérateur terrain.",
      body: "Un profil rare : quelqu'un qui a construit des entreprises, piloté des conformités complexes et déployé de l'IA dans des organisations réelles. Il parle la langue des dirigeants — marges, risques, délais — pas celle des slides.",
      chips: ["ENTREPRENEUR", "COMPLIANCE LEAD", "OPÉRATEUR TERRAIN"],
      quote: "« Je ne vends pas de l'IA. Je vends des organisations qui gagnent avec. »",
    },
    proof: {
      overline: "PREUVES",
      big: "Pas de logos empruntés. Pas de cas fabriqués.",
      sub: "Les résultats réels se montrent en direct, à l'écran, pendant votre appel découverte. Réservez 30 minutes — nous vous montrons tout.",
      cta: "Voir les cas en direct",
    },
    booking: {
      title: "Appel découverte — 30 min",
      step1: "Choisissez un créneau",
      step2: "Vos coordonnées",
      step3: "Confirmé",
      tz: "Europe/Paris — en direct, sans engagement",
      next: "Continuer",
      back: "Retour",
      name: "Nom complet",
      email: "Email professionnel",
      company: "Société",
      message: "Votre contexte (optionnel)",
      submit: "Réserver ce créneau",
      loading: "Réservation…",
      successTitle: "C'est réservé.",
      successBody: "Un email de confirmation vient de partir. Nous préparerons des cas réels à vous montrer en direct.",
      conflict: "Ce créneau vient d'être pris. Choisissez-en un autre.",
      error: "Une erreur est survenue. Réessayez.",
      noSlots: "Aucun créneau ce jour-là.",
    },
    footer: {
      big: "PARLONS TERRAIN.",
      cta: "Réserver un appel",
      contact: "Ouvrir l'agenda →",
      cities: "PARIS — BRUXELLES — AMSTERDAM — BERLIN",
      admin: "Accès studio",
      rights: "© 2026 TERRAIN. Studio de déploiement IA.",
    },
    admin: {
      loginTitle: "Accès studio",
      email: "Email",
      password: "Mot de passe",
      login: "Se connecter",
      logout: "Déconnexion",
      title: "Demandes de rendez-vous",
      empty: "Aucune demande pour le moment.",
      date: "Date",
      slot: "Créneau",
      name: "Nom",
      company: "Société",
      message: "Message",
      status: "Statut",
      loginError: "Identifiants invalides.",
    },
  },
  en: {
    nav: {
      manifesto: "Manifesto",
      services: "Services",
      approach: "The founder",
      proof: "Proof",
      book: "Book a call",
      studio: "AI DEPLOYMENT STUDIO — EU",
    },
    hero: {
      overline: "AI DEPLOYMENT STUDIO — EUROPE",
      lines: ["AI ALONE", "NEVER PAYS", "OFF."],
      sub: "AI deployment strategy & forward deployment engineering. We embed in your business, train your teams, and make your models profitable.",
      cta1: "Book a discovery call",
      cta2: "Read the manifesto",
      ticks: ["ROI FIRST", "AI ACT READY", "FR · EN · DE"],
      caption: "PARIS — 48.8566° N, 2.3522° E",
      scroll: "SCROLL",
    },
    marquee: ["FORWARD DEPLOYMENT", "AI STRATEGY", "COMPLIANCE", "ENABLEMENT", "ROI", "TERRAIN"],
    manifesto: {
      overline: "THE MANIFESTO",
      heading: "Four truths the market refuses to hear.",
      chapters: [
        {
          n: "01",
          t: "Unguided AI is a cost.",
          b: "Licenses bought, pilots abandoned, teams routing around the tool. AI deployed without guidance produces no return — it consumes it. Profitability is not a model feature: it is a deployment discipline.",
        },
        {
          n: "02",
          t: "Business first. Model second.",
          b: "You cannot automate what you do not understand. We start on the ground: your processes, your constraints, your margins. Technology comes after — calibrated to your operational reality, never the other way around.",
        },
        {
          n: "03",
          t: "Enablement beats delivery.",
          b: "A tool delivered without adoption is a disguised failure. We train your teams, install usage rituals and measure adoption until AI becomes a collective reflex — not an expense line.",
        },
        {
          n: "04",
          t: "Compliance is an edge.",
          b: "AI Act, GDPR, governance: what others endure, we turn into a sales argument. A compliant deployment is a durable deployment — and a trust signal for your clients.",
        },
      ],
    },
    services: {
      overline: "SERVICES",
      heading: "What we deploy, we make profitable.",
      items: [
        {
          n: "S.01",
          t: "AI Deployment Strategy",
          b: "Process audit, use cases prioritized by ROI, a 90-day deployment roadmap. Zero gut-feel steering.",
        },
        {
          n: "S.02",
          t: "Forward Deployment Engineering",
          b: "Engineers embedded in your teams, building on your ground — with your data, your tools, your constraints.",
        },
        {
          n: "S.03",
          t: "Enablement & Training",
          b: "Team training, adoption rituals, usage measurement. AI becomes a collective reflex, not a boardroom gadget.",
        },
        {
          n: "S.04",
          t: "Compliance & AI Act",
          b: "Risk mapping, governance, European compliance. Turn regulation into a commercial argument.",
        },
      ],
    },
    founder: {
      overline: "THE FOUNDER",
      heading: "Entrepreneur. Compliance lead. Field operator.",
      body: "A rare profile: someone who has built companies, steered complex compliance programs and deployed AI inside real organizations. He speaks the language of executives — margins, risk, deadlines — not the language of slide decks.",
      chips: ["ENTREPRENEUR", "COMPLIANCE LEAD", "FIELD OPERATOR"],
      quote: "“I don't sell AI. I sell organizations that win with it.”",
    },
    proof: {
      overline: "PROOF",
      big: "No borrowed logos. No fabricated cases.",
      sub: "Real results are shown live, on screen, during your discovery call. Book 30 minutes — we show you everything.",
      cta: "See the cases live",
    },
    booking: {
      title: "Discovery call — 30 min",
      step1: "Pick a slot",
      step2: "Your details",
      step3: "Confirmed",
      tz: "Europe/Paris — live, no commitment",
      next: "Continue",
      back: "Back",
      name: "Full name",
      email: "Work email",
      company: "Company",
      message: "Your context (optional)",
      submit: "Book this slot",
      loading: "Booking…",
      successTitle: "You're booked.",
      successBody: "A confirmation email is on its way. We will prepare real cases to show you live.",
      conflict: "That slot was just taken. Pick another one.",
      error: "Something went wrong. Try again.",
      noSlots: "No slots on this day.",
    },
    footer: {
      big: "LET'S TALK TERRAIN.",
      cta: "Book a call",
      contact: "Open the calendar →",
      cities: "PARIS — BRUSSELS — AMSTERDAM — BERLIN",
      admin: "Studio access",
      rights: "© 2026 TERRAIN. AI deployment studio.",
    },
    admin: {
      loginTitle: "Studio access",
      email: "Email",
      password: "Password",
      login: "Sign in",
      logout: "Sign out",
      title: "Booking requests",
      empty: "No requests yet.",
      date: "Date",
      slot: "Slot",
      name: "Name",
      company: "Company",
      message: "Message",
      status: "Status",
      loginError: "Invalid credentials.",
    },
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState("fr");
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, t: dict[lang] }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
